module.exports = __webpack_public_path__ + "img/Lock.8901af7c.svg";